import React, { useMemo, useState } from "react";
import { useAtom } from "jotai";

import { Calendar } from "components/Calendar/Calendar";
import { NamedSelect } from "components/NamedSelect/NamedSelect";
import { Option } from "components/Select/Select";
import { SimpleInput } from "components/SimpleInput/SearchInput";

import DaysServices from "utils/days";

import { EDocumentsMainFilters } from "../../types/documents";
import { documentsFiltersAtom } from "../../atoms/documentsAtom";
import { storesAtom } from "../../atoms/storeAtom";

import styles from "./styles.module.css";

interface HeaderProps {
  inputs: EDocumentsMainFilters[] | undefined;
}

export const Header = ({ inputs }: HeaderProps): JSX.Element => {
  const [visibleCalendarStart, setVisibleCalendarStart] =
    useState<boolean>(false);
  const [visibleCalendarEnd, setVisibleCalendarEnd] = useState<boolean>(false);

  const [documentsFilters, setDocumentsFilters] = useAtom(documentsFiltersAtom);
  const [stores] = useAtom(storesAtom);

  const storesOptions: Option[] = useMemo(
    () => stores.map((i) => ({ value: i.storesid, label: i.name })),
    [stores]
  );

  const storeVal: Option | undefined = useMemo(
    () =>
      storesOptions.find((i) => +i.value === Number(documentsFilters?.storeid)),
    [storesOptions, documentsFilters.storeid]
  );

  const store2Val: Option | undefined = useMemo(
    () =>
      storesOptions.find(
        (i) => +i.value === Number(documentsFilters?.store2id)
      ),
    [storesOptions, documentsFilters.store2id]
  );

  if (!inputs) return <></>;

  return (
    <>
      <div className="flex items-center my-4 flex-wrap gap-y-2">
        {inputs.includes(EDocumentsMainFilters.dateFrom) && (
          <div className={styles.wrapper}>
            <div className={styles.title}>Начальная дата:</div>
            <Calendar
              onShow={() => setVisibleCalendarStart(!visibleCalendarStart)}
              setVisibleCalendar={setVisibleCalendarStart}
              visibleCalendar={visibleCalendarStart}
              onChange={(val) =>
                setDocumentsFilters({
                  dateFrom: DaysServices.getDayStart(val),
                } as any)
              }
              value={documentsFilters.dateFrom || new Date()}
            />
          </div>
        )}
        {inputs.includes(EDocumentsMainFilters.dateTo) && (
          <div className={styles.wrapper}>
            <div className={styles.title}>Конечная дата:</div>
            <Calendar
              onShow={() => setVisibleCalendarEnd(!visibleCalendarEnd)}
              setVisibleCalendar={setVisibleCalendarEnd}
              visibleCalendar={visibleCalendarEnd}
              onChange={(val) => {
                setDocumentsFilters({
                  dateTo: DaysServices.getDayEnd(val),
                } as any);
              }}
              value={documentsFilters.dateTo || new Date()}
            />
          </div>
        )}
        {inputs.includes(EDocumentsMainFilters.store) && (
          <div className={styles.wrapper}>
            <NamedSelect
              options={storesOptions}
              name="Склад"
              value={storeVal}
              onChange={(val) =>
                setDocumentsFilters({ storeid: val?.value } as any)
              }
              placeholder={"Все"}
              isClearable
            />
          </div>
        )}
        {inputs.includes(EDocumentsMainFilters.store2) && (
          <div className={styles.wrapper}>
            <NamedSelect
              options={storesOptions}
              name="Склад-получатель"
              value={store2Val}
              onChange={(val) =>
                setDocumentsFilters({ store2id: val?.value } as any)
              }
              placeholder={"Все"}
              isClearable
            />
          </div>
        )}
      </div>
      {inputs.includes(EDocumentsMainFilters.search) && (
        <div className="mb-2">
          <SimpleInput
            value={documentsFilters.search || ""}
            onChange={(ev) =>
              setDocumentsFilters({ search: ev.target.value } as any)
            }
          />
        </div>
      )}
    </>
  );
};
